import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {TabsItemObject} from '@PosterWhiteboard/items/tabs-item/tabs-item.class';

export function useGetKeyFromTabItem<T extends keyof TabsItemObject>(key: T): TabsItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.TAB) {
      const itemCopy = item as TabsItemObject;
      if (itemCopy?.[key] !== undefined) {
        return itemCopy[key];
      }
    }

    return undefined;
  });
}
